// extracted by mini-css-extract-plugin
module.exports = {"endOfPage":"endOfPage_endOfPage__1qUmu","mobile":"endOfPage_mobile__26efJ"};